import React, { useEffect, useRef, useState } from 'react';
import CloseSVG from '../../../../assets/svg/close.svg';
import Button from '../../../button';
import FormSelect from '../../../form-select';
import { useSendApplicantsEmailByStatus } from '../../../../redux/human-resources/hook/recruitment';
import { useGetOnboardingRecruitmentEmails } from '../../../../redux/email-templates/hook/recruitment';
import { useParams } from 'react-router-dom';
import AddSmallSVG from '../../../../assets/svg/add-icon-small.svg';
import AddRecruitmentEmailTemplate from './add-recruitment-email-template';
import Modal from '../../modal';

function SendStatusEmail({ isOpen, closeModal }) {
  const statusOptions = [
    {
      label: 'Not Reviewed',
      value: 0,
    },
    {
      label: 'Accepted',
      value: 1,
    },
    {
      label: 'Rejected',
      value: 2,
    },
    {
      label: 'Pending Acceptance',
      value: 3,
    },
  ];

  const [emailId, setEmailId] = useState();

  const { data: recruitmentEmails } = useGetOnboardingRecruitmentEmails();
  const [showAddEmailTemplate, setShowAddEmailTemplate] = useState(false);
  const { id } = useParams();

  const { mutateAsync: sendByStatus, isLoading } =
    useSendApplicantsEmailByStatus();
  const [status, setStatus] = useState(0);

  const submitForm = async () => {
    let payload = {
      review_status: status,
      email_template_id: emailId,
      recruitment_id: id,
    };
    await sendByStatus(payload).then(() => {
      closeModal();
    });
  };

  return (
    <Modal
      scrollable={true}
      className='!max-w-[600px] !rounded-none'
      isOpen={isOpen}
      centered={true}
    >
      <div className='flex flex-col overflow-auto'>
        {showAddEmailTemplate ? (
          <AddRecruitmentEmailTemplate
            isOpen={showAddEmailTemplate}
            closeModal={() => setShowAddEmailTemplate(false)}
            templateData={null}
            buttonText={'Save'}
            title='Add Email Template'
          />
        ) : null}
        <form className='form pb-2'>
          <div className='pl-6 pr-6 pt-4'>
            <div className='flex flex-row justify-between items-center'>
              <span className='header-4'>Send Email By Applicant Status</span>
              <div className='cursor-pointer' onClick={() => closeModal()}>
                <img src={CloseSVG} alt='close' />
              </div>
            </div>
          </div>
          <hr className='divider' />
          <div className='flex flex-col p-4 pt-2'>
            <div>
              <div className=''>
                <FormSelect
                  value={status}
                  options={statusOptions}
                  onChange={(selected) => {
                    setStatus(selected);
                  }}
                  label='Select Status To Send Email'
                />
              </div>
            </div>
            <hr className='divider' />
            <div>
              <div className=''>
                {recruitmentEmails ? (
                  <FormSelect
                    value={emailId}
                    options={recruitmentEmails}
                    readOnly={recruitmentEmails ? false : true}
                    onChange={(selected) => {
                      setEmailId(selected);
                    }}
                    label='Select Email Template'
                  />
                ) : (
                  <div className='p4-medium text-color-gray'>
                    No Email Template Found. Click link below to add a new Email
                    Template.
                  </div>
                )}
                <hr className='divider' />
                <div className='flex flex-row items-center gap-2 justify-left w-full cursor-pointer'>
                  <img
                    src={AddSmallSVG}
                    alt={'add email template'}
                    className={'h-[15px] w-[15px]'}
                  />
                  <span
                    className='p4-medium hover:underline hover:italic hover:font-bold text-primary-3 duration-75'
                    onClick={() => setShowAddEmailTemplate(true)}
                  >
                    Add Email Template
                  </span>
                </div>
              </div>
            </div>
            <div className='w-full mt-[20px]'>
              <Button
                text={'Send Email'}
                theme={'third'}
                type='button'
                onClick={() => {
                  submitForm();
                }}
                loading={isLoading}
              />
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
}

export default SendStatusEmail;
